export default "__VITE_ASSET__3cb44b35__"